module.exports = __webpack_public_path__ + "static/media/Skarner.48ef4fba.png";